import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail32 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>
            這堂課適合誰? <br />
            我可以在這堂課獲得什麼?
          </span>
        </h2>
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>
            準備好你自己回答<span>Coding Interview面試</span>中的問題
          </li>
          <li>
            使用Python or JavaScirpt寫出「XOR Cipher」、「Poly alphabetic
            Cryptography」、「
            <span>RSA加密演算法</span>」、「
            <span>橢圓曲線加密演算法</span>
            」、「<span>DHKE金鑰交換</span>」與「身分驗證」等演算法
          </li>
          <li>透過演算法將資料做加密與解密，用於資料傳輸與驗證。</li>
          <li>
            學會並且證明數論的重要定理，包含Modular Arithematic、Primality
            Test、「
            <span>費馬小定理</span>」、「
            <span>中國剩餘定理</span>
            」、「
            <span>歐拉定理</span>」等等。
          </li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>對資料科學、機器學習、人工智慧有興趣的Python開發工程師</li>
          <li>對網頁前端後端有興趣，能夠使用基本JavaScript的工程師</li>
          <li>正在大學就讀資訊工程、電腦科學、資料科學、數學的學生</li>
          <li>對於演算法與網路結構有興趣者</li>
          <li>對於研究應用數學有興趣的人</li>
          <li>正在準備學習演算法以及資料結構的人</li>
          <li>數學系或應用數學系，想要轉考資工研究所或資管研究所的人</li>
          <li>對於IT, MIS有興趣學習者</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail32;
